function ConsultantSearch() {
  return <div>Consultant Search</div>;
}

export default ConsultantSearch;
